/* TBC offer tab (sections/tbc-offer.liquid).

   The tab opens the overlay; nothing opens by itself, except the page that
   comes back from the signup form, which shows its own result. A successful
   signup applies the discount code to the session (/discount/<code> sets the
   checkout's discount cookie) and the tab is not shown again in this browser
   for the same code. */

(function () {
  if (window.tbcOffer) return;

  var html = document.documentElement;
  var current = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function init(host) {
    var tab = host.querySelector('[data-tbc-offer-open]');
    var layer = host.querySelector('[data-tbc-offer-layer]');
    var code = host.getAttribute('data-code');
    var claimKey = 'tbc-offer:' + host.getAttribute('data-claim-key');
    var opener = null;

    function isClaimed() {
      try { return localStorage.getItem(claimKey) === '1'; } catch (error) { return false; }
    }

    function setClaimed() {
      try { localStorage.setItem(claimKey, '1'); } catch (error) {}
    }

    function focusables() {
      return Array.prototype.filter.call(
        layer.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])'),
        function (node) { return node.offsetParent !== null; }
      );
    }

    function onKey(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === layer)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (!layer.hidden) return;
      opener = document.activeElement;
      layer.hidden = false;
      html.classList.add('tbc-offer-lock');
      /* On a touch screen a focused field opens the keyboard at once, before
         the overlay has settled, and the keyboard covers the field; there the
         dialog takes focus and the keyboard waits for a tap on the field. */
      var field = window.matchMedia('(pointer: fine)').matches && layer.querySelector('.tbc-offer__input');
      (field || layer).focus({ preventScroll: true });
      document.addEventListener('keydown', onKey);
    }

    function close() {
      if (layer.hidden) return;
      layer.hidden = true;
      html.classList.remove('tbc-offer-lock');
      document.removeEventListener('keydown', onKey);
      var back = !tab.hidden ? tab : opener;
      if (back && back.focus && document.contains(back)) back.focus({ preventScroll: true });
    }

    tab.addEventListener('click', open);

    layer.addEventListener('click', function (event) {
      if (event.target.closest('[data-tbc-offer-close]')) {
        close();
        return;
      }
      /* The page shows through to the right of the column: a click there closes. */
      if (event.target === layer) close();
    });

    var form = layer.querySelector('[data-tbc-offer-form]');
    if (form) {
      form.addEventListener('submit', function () {
        var submit = form.querySelector('[data-tbc-offer-submit]');
        if (submit) submit.setAttribute('aria-busy', 'true');
      });
    }

    /* Back from the signup form: Shopify reloads the page with customer_posted
       or with the form's errors. */
    var success = layer.querySelector('[data-tbc-offer-success]');
    var failed = layer.querySelector('[data-tbc-offer-error]');

    if (success) {
      setClaimed();
      if (code) fetch(root() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        url.hash = '';
        window.history.replaceState(null, '', url.toString());
      }
    }

    tab.hidden = host.hasAttribute('data-editor-only') || isClaimed();
    if (success || failed) open();

    return { host: host, id: host.getAttribute('data-section-id'), open: open, close: close };
  }

  function start() {
    var host = document.querySelector('[data-tbc-offer]');
    if (current && current.host === host) return;
    current = host ? init(host) : null;
  }

  /* Theme editor: the section re-renders on every change, and selecting it
     or one of its blocks shows the overlay. */
  function mine(event) {
    return current && event.detail && event.detail.sectionId === current.id;
  }

  document.addEventListener('shopify:section:load', function () {
    var host = document.querySelector('[data-tbc-offer]');
    if (current && current.host === host) return;
    html.classList.remove('tbc-offer-lock');
    start();
  });
  document.addEventListener('shopify:section:select', function (event) { if (mine(event)) current.open(); });
  document.addEventListener('shopify:block:select', function (event) { if (mine(event)) current.open(); });
  document.addEventListener('shopify:section:deselect', function (event) { if (mine(event)) current.close(); });

  window.tbcOffer = true;
  start();
})();
